// extracted by css-extract-rspack-plugin
var _1 = "okXcb4Sggm0riHKU";
export { _1 as "subList" }
// extracted by css-extract-rspack-plugin
var _1 = "okXcb4Sggm0riHKU";
export { _1 as "subList" }
